class UmdOption {
    //외부에서 OACX.options을 통해 접근하는 key 
    constructor(){
        this.style = {
            disabled_userInfo(){
                this.userInfo.name.off()
                this.userInfo.phone1.off()
                this.userInfo.phone2.off()
                this.userInfo.ssn1.off()
                this.userInfo.ssn2.off()
                this.userInfo.telcoTy.off()
            },
            show_userInfo(){
                this.userInfo.name.on()
                this.userInfo.phone1.on()
                this.userInfo.phone2.on()
                this.userInfo.ssn1.on()
                this.userInfo.ssn2.on()
                this.userInfo.telcoTy.on()
            },
            userInfo: {
                name: { // 이름
                    off(){ $(`#oacxEmbededContents input[data-id='oacx_name']`).attr("readonly","readonly").css("background","#f2f2fa") },
                    on(){ $(`#oacxEmbededContents input[data-id='oacx_name']`).removeAttr("readonly","readonly").css("background","none") }
                },
                ssn1: { // 주민번호 앞자리
                    off(){ $(`#oacxEmbededContents input[data-id='oacx_num1']`).attr("readonly","readonly").css("background","#f2f2fa") },
                    on(){ $(`#oacxEmbededContents input[data-id='oacx_num1']`).removeAttr("readonly","readonly").css("background","none") }
                },
                ssn2: { // 주민번호 뒷자리
                    off(){ $(`#oacxEmbededContents input[data-id='oacx_num2']`).attr("readonly","readonly").css("background","#f2f2fa") },
                    on(){ $(`#oacxEmbededContents input[data-id='oacx_num2']`).removeAttr("readonly","readonly").css("background","none") }
                },
                birthday: { // 생년월일
                    off(){ $(`#oacxEmbededContents input[data-id='oacx_birth']`).attr("readonly","readonly").css("background","#f2f2fa") },
                    on(){ $(`#oacxEmbededContents input[data-id='oacx_birth']`).removeAttr("readonly","readonly").css("background","none") }
                },
                telcoTy: { // 통신사 SK, KT, LG 
                    off(){ $(`#oacxEmbededContents select[data-id='oacx_phone0']`).attr("disabled","disabled").css("background","#f2f2fa").css("opacity","1") },
                    on(){ $(`#oacxEmbededContents select[data-id='oacx_phone0']`).removeAttr("disabled").css("background","").css("opacity","") }
                },
                phone1: { // 휴대폰번호 앞자리
                    off(){ $(`#oacxEmbededContents select[data-id='oacx_phone1']`).attr("disabled","disabled").css("background","#f2f2fa").css("opacity","1"); },
                    on(){ $(`#oacxEmbededContents select[data-id='oacx_phone1']`).removeAttr("disabled").css("background","").css("opacity","") }
                },
                phone2: { // 휴대폰번호 뒷자리
                    off(){ $(`#oacxEmbededContents input[data-id='oacx_phone2'], #oacxEmbededContents input[data-id='oacx_phone3']`).attr("readonly","readonly").css("background","#f2f2fa") },
                    on(){ $(`#oacxEmbededContents input[data-id='oacx_phone2'], #oacxEmbededContents input[data-id='oacx_phone3']`).removeAttr("readonly","readonly").css("background","none") }
                }
            },            
            showStep1(){
                $(`#oacxEmbededContents .standby`).hide();
                $(`#oacxEmbededContents .mobileView`).show();
                $(`#oacxEmbededContents .main-content`).show();
                $(`#oacxEmbededContents .csTxt`).removeClass("view");
                $(`#oacxEmbededContents .pcView`).show();
                $(`#oacxEmbededContents .csTxt`).hide();
            },
            showStep2(providerId){
                $(`.csTxt.view`).removeClass("view");
                $(`#div_${providerId}`).addClass("view");
                $(`#oacxEmbededContents .standby`).show();
                $(`#oacxEmbededContents .mobileView`).hide();
                $(`#oacxEmbededContents .main-content`).hide();
                $(`#oacxEmbededContents .csTxt:lt(1)`).addClass("view");
                $(`#oacxEmbededContents .pcView`).hide();
                $(`#oacxEmbededContents .csTxt:lt(1)`).show();
            }
        }
        this.trigger = {
            request:()=>{}
        }
        this.callback = { 
            loaded:()=>{ },
            ajax:{
                success:{
                    getToken:()=>{ }, //토큰발급
                    providerList:()=>{ }, //인증기관 목록
                    authRequest:()=>{ }, //인증요청 성공
                    authComplete:()=>{ } //인증완료 성공
                },
                fail:{
                    getToken:()=>{ }, //토큰발급
                    providerList:()=>{ }, //인증기관 목록 조회
                    authRequest:()=>{ }, //인증요청
                    authRequestAlertConfirm:()=>{ }, //인증요청 [확인]
                    authComplete:()=>{ }, //인증완료
                    authCompleteAlertConfirm:()=>{ } //인증완료 [확인]
                }
            },
            event:{
                close:()=>{ }, //모든 닫기 이벤트
                request:()=>{ }, //인증요청 이벤트
            },
            valid:{
                error:()=>{ }
            }
        }
    }

}
export default (new UmdOption);